import { EnvironmentTypes } from '~/api';

export enum FeatureFlagKeys {
  SOCIAL_CONNECTION = 'social_connection',
  MANAGE_ENVIRONMENT = 'manage_environment',
  PORTAL_CUSTOMIZATION = 'portal_customization',
  APPLICATION_SETTINGS = 'application_settings',
  WEBHOOKS = 'webhooks',
  SINGLE_SIGNON = 'sso',
  DIRECTORY_SYNC = 'dir_sync',
  GBRA = 'gbra',
  BILLING = 'billing',
  WORKSPACE_BILLING = 'workspace_billing',
  SIGNUP = 'signup',
  GETTING_STARTED = 'getting_started',
  QUICK_START = 'quick_start',
  USERS = 'users',
  PORTAL_CUSTOMIZATION_DISALLOW_DISABLE_CONNECTION = 'portal_customization_disallow_disable_connection',
  CUSTOM_DOMAIN = 'cname_enabled',
  OAUTH_CONFIGURATION_TYPE_OPTIONS = 'use_platform_credentials_for_environment',
  AUTHENTICATION_METHODS = 'authentication_methods',
  SESSION_MANAGEMENT = 'session_management',
  FSA_CUSTOMIZATION_ENABLED = 'fsa_customization_enabled',
  NEED_HELP_WITH_REVENUE_HERO = 'need_help_with_revenue_hero',
  USER_MANAGEMENT_SETTINGS = 'user_management_settings',
  EMAIL_CONFIGURATION = 'email_configuration',
  FSA_REDIRECT_URI = 'fsa_redirect_uri',
  FSA_AUTHORIZATION = 'fsa_authorization',
  FSA_PERMISSIONS = 'fsa_permissions',
  FULL_STACK_AUTHENTICATION = 'full_stack_authentication',
  FSA_PACKAGING = 'fsa_packaging',
  MCP_SERVERS = 'mcp_servers',
  SCALEKIT_CONNECT = 'scalekit_connect',
  FSA_SETTINGS = 'fsa_settings',
  AUTHENTICATION_LOGS = 'authentication_logs',
  ORGANIZATION_ROLES = 'organization_roles',
  EMAIL_TEMPLATES = 'email_templates',
  SIGNUP_RESTRICTIONS = 'signup_restrictions',
  INTERCEPTORS = 'interceptors',
  PASSKEYS = 'passkeys',
  CIMD_CLIENTS = 'cimd_clients'
}

export enum OrganizationAuthFeatures {
  ALLOW_ORGANIZATION_SIGNUP = 'allow_organization_signup'
}

type FeatureFlagValue = string | boolean;

export interface FeatureSettings {
  name: FeatureFlagKeys;
  enabled: boolean;
}

export interface FeatureFlagData {
  value: FeatureFlagValue;
  key: FeatureFlagKeys;
  reason?: string;
  variant?: string;
  metadata?: Record<string, any>;
}

export interface OpenFeatureListResponse {
  flags: FeatureFlagData[];
}

export type FeatureFlagMap = Partial<
  Record<FeatureFlagKeys, FeatureFlagData>
> | null;

export type GetFeatureFlagRequest = {
  workspaceId: string;
  environmentType: EnvironmentTypes;
  targetingKey: string;
  workspaceCreatedAt: number;
};

export interface ListEnvironmentFeaturesResponse {
  features: FeatureSettings[];
}

export interface ToggleEnvironmentFeatureRequest {
  environmentId: string;
  feature: FeatureFlagKeys;
  status: 'enable' | 'disable';
}

export type OrganizationAuthFeaturesMapType = {
  [OrganizationAuthFeatures.ALLOW_ORGANIZATION_SIGNUP]?: boolean;
};
